import React, {useEffect} from 'react';
import {useStyles} from "./styles/StatisticsStyle";
import {
    Box,
    TablePagination,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    TableContainer,
    FormControl,
    Select,
    MenuItem,
    TextField,
    Button,
    Typography
} from "@material-ui/core";
import PropTypes from 'prop-types';
import {ReactComponent as AlignLeftIcon} from '../../../common/images/AlignLeftIcon.svg';
import {ReactComponent as TextFieldDownIcon} from '../../../common/images/TextFieldDownIcon.svg';
import {ReactComponent as TableSortIcon} from '../../../common/images/TableSortIcon.svg';
import { ReactComponent as ArrowDownIcon } from '../../../common/images/ArrowDownIcon.svg';
import {inject, observer} from "mobx-react";
import {injectIntl} from "react-intl";
import {DATE_UTIL} from "../../../common/util/date/date.util";
import clsx from "clsx";
import {LocaleGroupType, LocaleType} from "../../../common/enums/MemberEnum";
import {useHistory} from "react-router-dom";

function TabPanel(props) {
    const {children, value, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <div>{children}</div>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function StatisticsHome(props) {
    const classes = useStyles();
    const history = useHistory();
    const {intl} = props;
    const {groupStore, authStore} = props;

    useEffect(() => {
        groupStore.initSearch();
        groupStore.getGroups(authStore.loginUser.id);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleChangeSearchType = (e) => {
        groupStore.setTempSearchType(e.target.value)
    }

    const handleChangeSearchText = (e) => {
        groupStore.setTempSearchText(e.target.value);
    }

    const handleChangePage = (event, newPage) => {
        groupStore.setPage(authStore.loginUser.id, newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        groupStore.setRowsPerPage(authStore.loginUser.id, parseInt(event.target.value, 10));
    };

    const searchTypeList = [{value: 'all', label: intl.formatMessage({id: 'All'})}];
    switch (groupStore.tempSearchType) {
        case 'groupType':
            for (const type in LocaleGroupType) {
                searchTypeList.push({value: type, label: intl.formatMessage({id: type})});
            }
            break;
        default:
            for (const local in LocaleType) {
                searchTypeList.push({value: local, label: intl.formatMessage({id: local})});
            }
            break;
    }

    const handleClickSearch = () => {
        groupStore.searchGroups(authStore.loginUser.id);
    }

    const handleClickCreatedDateSort = () => {
        if (groupStore.sortColumn === 'created_datetime') {
            groupStore.setIsSortAscending(!groupStore.isSortAscending);
        } else {
            groupStore.setSortColumn('created_datetime');
            groupStore.setIsSortAscending(false);
        }
        groupStore.getGroups(authStore.loginUser.id);
    };

    const handelClickManage = (id) => {
        history.push(`/statistics/detail/${id}`);
    }

    return (
        <Box className={classes.root}>
            <Box display={"flex"} justifyContent={"space-between"}>
            </Box>

            <Box>
                <Box position="static" className={classes.tabBox}>

                </Box>
                <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                    <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}
                         className={classes.searchBox}>
                        <FormControl className={classes.formControl}>
                            <Select
                                value={groupStore.tempSearchType}
                                onChange={handleChangeSearchType}
                                IconComponent={(props) => (
                                    <Box>
                                        <ArrowDownIcon  {...props} />
                                    </Box>
                                )}
                                MenuProps={{
                                    anchorOrigin: {
                                        vertical: "bottom",
                                        horizontal: "right"
                                    },
                                    transformOrigin: {
                                        vertical: 'top',
                                        horizontal: 'right',
                                    },
                                    getContentAnchorEl: null,
                                    className: classes.selectPopover
                                }}
                            >
                                <MenuItem value={'all'}>{intl.formatMessage({id: "All"})}</MenuItem>
                                <MenuItem value={'groupName'}>{intl.formatMessage({id: "group_name"})}</MenuItem>
                                <MenuItem value={'groupType'}>{intl.formatMessage({id: "group_type"})}</MenuItem>
                                <MenuItem value={'localeCode'}>{intl.formatMessage({id: "Locale"})}</MenuItem>
                            </Select>
                        </FormControl>
                        {groupStore.tempSearchType === 'all' || groupStore.tempSearchType === 'groupName' ?
                            <Box className={classes.textQuizBox}>
                                <TextField id="outlined-basic" variant="outlined"
                                           placeholder={groupStore.tempSearchType === 'all' ? '' : intl.formatMessage({id: "search_group_name"})}
                                           value={groupStore.tempSearchText} onChange={handleChangeSearchText}
                                           disabled={groupStore.tempSearchType === 'all'}/>
                            </Box>
                            :
                            <FormControl className={clsx(classes.formControl, classes.formControl2)}>
                                <Select
                                    value={groupStore.tempSearchText}
                                    onChange={handleChangeSearchText}
                                    IconComponent={(props) => (
                                        <Box>
                                            <ArrowDownIcon  {...props} />
                                        </Box>
                                    )}
                                    MenuProps={{
                                        anchorOrigin: {
                                            vertical: "bottom",
                                            horizontal: "right"
                                        },
                                        transformOrigin: {
                                            vertical: 'top',
                                            horizontal: 'right',
                                        },
                                        getContentAnchorEl: null,
                                        className: classes.selectPopover
                                    }}
                                >
                                    {searchTypeList.map((type, index) => (
                                        <MenuItem key={index} value={type.value}>{type.label}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        }

                        <Button className={clsx(classes.buttonStyle, classes.buttonStyle3)} disableRipple
                                onClick={handleClickSearch}>
                            <Typography>{intl.formatMessage({id: "search"})}</Typography>
                        </Button>
                    </Box>
                </Box>

                <Box>
                    <TableContainer className={classes.tableBox}>
                        <Table className={classes.table} aria-label="simple table">
                            <TableHead className={classes.tableHeadStyle}>
                                <TableRow>
                                    <TableCell
                                        align='left'
                                        style={{minWidth: 55}}
                                    >
                                        <Box className={classes.sortButton} style={{cursor: 'default'}}>
                                            <AlignLeftIcon/><Typography>{intl.formatMessage({id: "Locale"})}</Typography>
                                        </Box>
                                    </TableCell>
                                    <TableCell align="left" style={{minWidth: 55}}>
                                        <Box className={classes.sortButton} style={{cursor: 'default'}}>
                                            <AlignLeftIcon/><Typography>{intl.formatMessage({id: "LocaleAdmin"})}</Typography>
                                        </Box>
                                    </TableCell>
                                    <TableCell align="left" style={{minWidth: 55}}>
                                        <Box className={classes.sortButton} style={{cursor: 'default'}}>
                                            <AlignLeftIcon/><Typography>{intl.formatMessage({id: "group_type"})}</Typography>
                                        </Box>
                                    </TableCell>
                                    <TableCell align="left" style={{minWidth: 55}}>
                                        <Box className={classes.sortButton} style={{cursor: 'default'}}>
                                            <AlignLeftIcon/><Typography>{intl.formatMessage({id: "group_name"})}</Typography>
                                        </Box>
                                    </TableCell>
                                    <TableCell align="left" style={{minWidth: 55}}>
                                        <Box className={classes.sortButton} style={{cursor: 'default'}}>
                                            <AlignLeftIcon/><Typography>{intl.formatMessage({id: "account_count"})}</Typography>
                                        </Box>
                                    </TableCell>
                                    <TableCell align="left" onClick={handleClickCreatedDateSort}
                                               style={{minWidth: 120}}>
                                        <Box className={classes.sortButton}>
                                            <AlignLeftIcon/><Typography>{intl.formatMessage({id: "created_date"})}</Typography>
                                            {groupStore.sortColumn === 'created_datetime' &&
                                                (groupStore.isSortAscending ?
                                                    <TableSortIcon style={{transform: 'scaleY(-1)'}}/> :
                                                    <TableSortIcon/>)
                                            }
                                        </Box>
                                    </TableCell>
                                    <TableCell align="center"></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody className={classes.tableBodyStyle}>
                                {groupStore.groupList.map((group, index) => (
                                    <TableRow key={index}>
                                        <TableCell component="th" scope="row"
                                                   align='left'>{intl.formatMessage({id: group.localeCode})}</TableCell>
                                        <TableCell align="left">{group.localeAdminUserId}</TableCell>
                                        <TableCell align="left">{intl.formatMessage({id: group.groupType})}</TableCell>
                                        <TableCell align="left">{group.name}</TableCell>
                                        <TableCell align="left">{group.userCount}</TableCell>
                                        <TableCell
                                            align="left">{DATE_UTIL.getTimeZoneDate(group.createdDatetime, DATE_UTIL.FORMAT.DOT_DATE_FORMAT)}</TableCell>
                                        <TableCell align="center">
                                            <Button className={classes.tableButton} disableRipple
                                                    onClick={() => handelClickManage(group.id)}>{intl.formatMessage({id: "management"})}</Button>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination
                        rowsPerPageOptions={[10, 15, 20]}
                        count={groupStore.groupCount}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        labelRowsPerPage={intl.formatMessage({id: "rows_per_page"})}
                        page={groupStore.page}
                        rowsPerPage={groupStore.rowsPerPage}
                        component="div"
                        labelDisplayedRows={({count, page}) => {
                            return <span
                                className={classes.displayRow}><span>{page + 1}</span> / {Math.ceil(count / groupStore.rowsPerPage)}</span>
                        }}
                        SelectProps={{
                            IconComponent: TextFieldDownIcon,
                            MenuProps: {
                                className: classes.selectPopover
                            }
                        }}
                        className={classes.paginationBox}
                    />
                </Box>
            </Box>
        </Box>
    );
}

export default inject('groupStore', 'authStore')(injectIntl(observer(StatisticsHome)));
